export class ChargeThreshold {
	batteryNum = 1;
	isCapable = false;
	isEnabled = false;
	startValue = 40;
	stopValue = 45;
	checkboxValue = false;
}
